export default {
  title: {
    en: 'What you’re getting...',
  },
  text: {
    en: `
      A month-to-month subscription to Scentbird cases. Billed monthly, renews automatically,
      and ships from our warehouse with your fragrance.
    `,
  },
}
